import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { dripKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useValidateDrip = (dripId) => {
    const additional = useQueryRequestParams();
    return useQuery({
        queryKey: dripKeys.validate(dripId),
        queryFn: () => axios
            .post(markUrl('drips/validate/'), { drip_id: dripId }, additional)
            .then((r) => r.data),
        enabled: !!dripId
    });
};
export default useValidateDrip;
